module.exports = __webpack_public_path__ + "static/img/keHuKS.89335c43.png";